import React from "react";

const Gender = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M10.481 34v-2.837H7.538v-1.961h2.94c0-.847.006-1.656-.01-2.465-.002-.063-.158-.165-.252-.18-1.922-.308-3.571-1.14-4.9-2.55-1.653-1.752-2.467-3.839-2.293-6.24.245-3.385 1.99-5.783 5.07-7.224 1.086-.509 2.255-.718 3.458-.692.224.004.332-.078.443-.255 1.674-2.63 4.084-4.033 7.218-4.089 2.185-.038 4.112.724 5.744 2.184.101.091.2.184.302.274.015.013.038.018.091.043l4.319-4.058h-2.203V2h5.757v5.566h-1.957V5.25l-.077-.027-4.602 4.325c.262.634.552 1.225.755 1.844 1.281 3.912-.617 8.262-4.36 10.056a8.46 8.46 0 0 1-3.741.852c-.267-.002-.41.078-.548.298-1.396 2.226-3.415 3.531-6.016 3.968-.084.014-.215.12-.216.185-.015.8-.009 1.6-.009 2.432h3.063v1.967h-3.076V34H10.48Zm9.222-13.704c2.463-.047 5.391-1.977 5.96-5.295.553-3.239-1.426-6.37-4.523-7.269-3.114-.904-6.024.64-7.142 2.48 4.136 1.306 6.78 5.568 5.705 10.084Zm-8.667-8.457c-2.802.047-5.423 2.35-5.961 5.208-.567 3.004 1.127 6.059 3.948 7.17 2.996 1.179 6.19-.007 7.734-2.277-2.122-.701-3.771-1.986-4.875-3.919-1.104-1.935-1.346-4-.846-6.182Zm6.62 8.284c1.205-3.61-1.272-7.42-4.594-8.085-1.14 3.441 1.064 7.265 4.594 8.085Z"
            fill={fill}
        />
    </svg>
);

export default Gender;